import React, { useEffect, useState } from 'react'
import { PaperCard, TextBlock } from '../../../components/1elements'

import { makeStyles } from '@material-ui/core/styles'
import { renderBucket } from './bucketRenderer'

import { Loader } from '../../../components/1elements'

const ListBucketCard = ({
  editMode,
  arrayOfBucketConfig,
  formikProps,
  children,
  disabled = false
}) => {
  const [collapsableContentHeight, SetCollapsableContentHeight] =
    useState('150px')
  useEffect(() => {
    const collapsableContentHeights = {
      1: '580px',
      2: '210px',
      3: '140px'
    }
    const numOfElementsInBucket = arrayOfBucketConfig?.length
    SetCollapsableContentHeight(
      collapsableContentHeights[numOfElementsInBucket] || '150px'
    )
  }, [arrayOfBucketConfig])

  const classes = useStyles({ collapsableContentHeight })
  if (!arrayOfBucketConfig) return <Loader />

  return (
    <PaperCard className={classes.column}>
      {arrayOfBucketConfig.map((oneBucket, index) => (
        <TextBlock key={index}>
          {renderBucket(
            oneBucket,
            formikProps,
            editMode,
            classes.dropDownCollapsableContent,
            disabled
          )}
        </TextBlock>
      ))}
      {children}
    </PaperCard>
  )
}

export default React.memo(ListBucketCard)

const useStyles = makeStyles((theme, props) => ({
  column: {
    height: '700px',
    padding: '20px 15px',
    border: `2px solid ${theme.palette.quaternary.accent}`,
    '&.MuiPaper-elevation3': {
      boxShadow: 'none'
    },
    '&::-webkit-scrollbar': {
      width: 5
    }
  },
  dropDownCollapsableContent: {
    '&+.MuiList-root': {
      maxHeight: props =>
        !props.collapsableContentHeight
          ? '140px'
          : props.collapsableContentHeight,
      overflowY: 'auto',
      '&::-webkit-scrollbar': {
        width: 5
      }
    }
  }
}))
